import styled from "styled-components";

export const Container = styled.div`
  /* padding: 54px 30px;*/
  background-color: var(--section-background);
  padding: 52px 28px 15px;
  width: 100%;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  max-height: calc(100vh - 84px);
  overflow: auto;
  position: relative;
  min-height: calc(100vh - 58px);
  overflow: hidden;
  .action-btn {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: center;
    svg {
      cursor: pointer;
    }
    &.mobile-only {
      display: none;
    }
  }
  @media (max-width: 850px) {
    padding: 13px;
    min-height: auto;
    max-height: calc(100vh - 185px);
    min-height: calc(100vh - 185px);
    .action-btn {
      &.mobile-only {
        display: flex;
      }
    }
  }
`;
export const TableContainer = styled.div`
  padding: 0;
  width: 100%;
  .table-head {
    th {
      :first-child {
        /* width: 50%; */
        text-align: left;
        padding-left: 77px;
      }
      :last-child {
        text-align: center;
        width: 128px;
      }
    }
  }
  .body {
    /* td:first-child {
      text-align: center;
    } */
    .text-wrapper {
      display: inline-grid;
      align-items: center;
      gap: 30px;
      grid-template-columns: 17px 1fr;
    }
  }
  @media (max-width: 850px) {
    .body {
      .text-wrapper {
        grid-template-columns: 1fr;
      }
    }
  }
`;
export const Heading = styled.div`
  padding-right: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px 14px;
  width: 100%;
  flex-wrap: wrap;

  .add-new-msg {
    background-color: var(--input-background);
  }
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 31px;
    color: #000000;
  }
  p {
    font-size: 14px;
    color: #000000b3;
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const MainSection = styled.div`
  display: flex;
  align-items: flex-start;
  max-height: calc(100vh - 428px);
  overflow: auto;
  &.add-height {
    max-height: calc(100vh - 274px);

  }
  @media (max-width: 881px) {
    max-height: calc(100vh - 467px);
  }
  @media (max-width: 850px) {
    max-height: calc(100vh - 428px);
  }
  @media (max-width: 717px) {
    max-height: calc(100vh - 491px);
  }
  @media (max-width: 550px) {
    max-height: calc(100vh - 527px);
  }
`;

export const AddNewMsg = styled.div`
  padding: 22px 0;
  border-bottom: 1px solid #00000014;
  button {
    font-family: "latobold";
  }
`;

export const AlertsSection = styled.div``;

export const WorkSection = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
  padding: 30px 40px;

  > div {
    display: flex;
    align-items: flex-end;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 10px;
    .text-with-icon {
      font-size: 13px;
      line-height: 150.5%;
      display: flex;
      align-items: center;
      gap: 7px;
      margin-bottom: 10px;
    }
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .select-wrapper {
    .select {
      margin-bottom: 10px;
      margin-top: 4px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
    }
    .MuiFormControl-root {
      margin: 0;
      width: 100%;
    }
    .MuiSelect-select {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      font-size: 13px;
      padding: 2.5px 10px;
    }
  }
  @media (max-width: 1250px) {
    > div {
      justify-content: flex-start;
    }
  }
  @media (max-width: 850px) {
    padding: 18px 12px 10px;
  }
  @media (max-width: 550px) {
    padding: 18px 12px 10px;
    > div {
      > div {
        width: 100%;
      }
    }
  }
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  label {
    margin: 0;
  }
  &.no-side-border {
    ::after {
      display: none;
    }
  }

  .checkbox {
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    min-width: 270px;
    min-height: 30px;
  }
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 5px;
  }
  .MuiTypography-root {
    font-size: 13px;
    white-space: normal;
    padding-right: 30px;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
  }
`;

export const AddNewMsgModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  height: 100%;
  background: var(--modal-back-bg);
  z-index: 1;
  .fleet-car-msg {
    max-width: 344px;
    margin: 0 auto;
    width: 100%;
    .inner-wrapper {
      padding: 0 25px;
    }
    .box-heading {
      margin: 10px 0 18px;
      .close-icon {
        cursor: pointer;
      }
    }
  }
`;
export const EditMsgModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  height: 100%;
  background: var(--modal-back-bg);
  z-index: 1;
  display: flex;
  justify-content: center;
`;
